import { useBrand } from '../../contexts/BrandingContext';
import { useAuth } from '../../contexts/AuthContext';
import React from 'react';
import { useTenant } from '../../contexts/TenantContext';
import SaasHeader from './saas/SaasHeader';

interface HeaderProps {
  isMegaMenuLoaded?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ isMegaMenuLoaded }) => {
  const { branding } = useBrand();
  const { isAuthenticated } = useAuth();
  const { isAddEditHost } = useTenant();

  // If we have branding but aren't authenticated yet, show appropriate header
  if (!isAuthenticated) {
    // If the flag is true, use the same header as authenticated users
    if (
      branding?.usecustomheaderandfooterunauthenticated &&
      branding?.customheader
    ) {
      return (
        <div
          data-app-header
          dangerouslySetInnerHTML={{ __html: branding.customheader }}
        />
      );
    }

    // Otherwise, use the dedicated unauthenticated header if available
    if (branding?.customunauthenticatedheader) {
      return (
        <div
          data-app-header
          dangerouslySetInnerHTML={{
            __html: branding.customunauthenticatedheader,
          }}
        />
      );
    }

    return null; // No header for unauthenticated users without custom content
  }

  // show the unauthenticated experience if the mega menu is still loading
  if (
    !isMegaMenuLoaded &&
    branding?.customunauthenticatedheader &&
    !branding?.customheader
  ) {
    return (
      <div
        data-app-header
        dangerouslySetInnerHTML={{
          __html: branding.customunauthenticatedheader,
        }}
      />
    );
  }

  // For authenticated users: use customheader if available
  if (branding?.customheader) {
    return (
      <div
        data-app-header
        dangerouslySetInnerHTML={{ __html: branding.customheader }}
      />
    );
  }

  if (isAddEditHost()) {
    return (
      <div data-app-header>
        <SaasHeader />
      </div>
    );
  }

  return null;
};
